import { Box, Container, Grid } from "@mui/material";
import React, { useRef } from "react";
import { AllImage, IconStyle, LinkStyle, List, ListItems, Ulist } from "../styling/style";
import XIcon from '../assets/x-icon.png';
import Telegram from '../assets/telegram.png';
import Header from "./1-header";
import styled from "@emotion/styled";
import Logo from '../assets/logo.png';
import Background from '../assets/header-background.png';
import { MuiDrawer } from "../components/mui-drawer";
import HeaderEnd from "./header-end";
import About from "./2-about";
import Features from "./3-features";
import RoadMap from "./4-roadmap";
import Partner from "./5-partners";
import FAQ from "./6-faq";
import End from "./7-end";
import Revenue from "./8-revenue-sharing";
import Tokenomics from "./peachy-tokenomics";
import WallOfFame from "../page 2/9-wallOfFlame";
import { Outlet, Route, Routes } from "react-router-dom";

const BackgroundDiv = styled.div`
    background-image: url(${Background});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    min-height: 113vh;
    @media (max-width: 599px){
        min-height: 100vh;
    }
    @media (min-width: 1800px){
        min-height: 84vh;
    }
    @media (min-width: 800px) and (max-width: 900px){
        min-height: 125vh;
    }
    @media (min-width: 600px) and (max-width: 800px){
        min-height: 100vh;
    }
`

const MainGrid = styled(Grid)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
`

const IconBox = styled(Box)`
    @media (max-width: 950px){
        display: none;
    }
`
const Menu = () => {
    return(
        <div style={{ backgroundColor: 'black' }}>
            <Container maxWidth='lg'>
                    <Grid container>
                        <MainGrid xs={12}>
                            <Ulist>
                                <AllImage maxw='180px' p='0px 20px 0px 0px' src={Logo} />
                                <List bl='1px solid #FFFFFF'><ListItems href="/">Home</ListItems></List>
                                <List><ListItems  href="/#about" >About</ListItems></List>
                                <List><ListItems  href="/#features" >Features</ListItems></List>
                                {/* <List><ListItems>
                                    <LinkStyle to="/walloffame">
                                        Wall of Fame
                                    </LinkStyle>
                                    </ListItems></List> */}
                                <List><ListItems  href="">$PEACHY</ListItems></List>
                                {/* <List><ListItems  href="">Whitepaper</ListItems></List>
                                <List><ListItems  href="/#faq">FAQ</ListItems></List> */}
                            </Ulist>
                            <MuiDrawer/>
                            <IconBox>
                                <IconStyle href="https://twitter.com/peachy_trader"><AllImage maxw='20px' src={XIcon} /></IconStyle>
                                <IconStyle href="https://t.me/peachy_trader"><AllImage maxw='20px' src={Telegram} /></IconStyle>
                            </IconBox>
                        </MainGrid>
                    </Grid>
            </Container>
        </div>
    )
}
export default Menu;